interface PersonaScenarioDataInput {
  id: string
  personaId: string
  name: string
  scenarioSetting: string
  weight: number
  createdAt: Date
  updatedAt: Date
}

export interface PersonaScenarioData {
  id: string
  personaId: string
  name: string
  scenarioSetting: string
  weight: number
  createdAt: Date
  updatedAt: Date
}

interface PersonaDataInput {
  id: string
  name: string
  gender: string
  occupation: string
  literacyLevel: string
  scene?: string | null
  purpose?: string | null
  estimatedMinutes?: number | null
  skillMapId: string
  phaseIds?: string[]
  scenarios?: PersonaScenarioDataInput[]
  createdAt: Date
}

export interface PersonaData {
  id: string
  name: string
  gender: string
  occupation: string
  literacyLevel: string
  scene?: string | null
  purpose?: string | null
  estimatedMinutes?: number | null
  skillMapId: string
  phaseIds: string[]
  scenarios: PersonaScenarioData[]
  createdAt: Date
}

export function mappingPersonaScenario(
  scenario: PersonaScenarioDataInput,
): PersonaScenarioData {
  return {
    id: scenario.id,
    personaId: scenario.personaId,
    name: scenario.name,
    scenarioSetting: scenario.scenarioSetting,
    weight: scenario.weight,
    createdAt: new Date(scenario.createdAt),
    updatedAt: new Date(scenario.updatedAt),
  }
}

export function mappingPersona(persona: PersonaDataInput): PersonaData {
  return {
    id: persona.id,
    name: persona.name,
    gender: persona.gender,
    occupation: persona.occupation,
    literacyLevel: persona.literacyLevel,
    scene: persona.scene,
    purpose: persona.purpose,
    estimatedMinutes: persona.estimatedMinutes,
    skillMapId: persona.skillMapId,
    phaseIds: persona.phaseIds || [],
    scenarios: persona.scenarios
      ? persona.scenarios.map(mappingPersonaScenario)
      : [],
    createdAt: new Date(persona.createdAt),
  }
}

export function mappingPersonas(personas: PersonaDataInput[]): PersonaData[] {
  return personas.map((persona) => mappingPersona(persona))
}
